import React, { FC, useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { OrganizationInfo } from '../../models/api-models/organization/organization-info';
import { PolicyService } from '../../services/PolicyService';
import { TermsAndConditions } from './TermsAndConditions/TermsAndConditions';

const policyComponents: Record<string, FC<{ organization: OrganizationInfo }>> = {
    'sms-terms': TermsAndConditions,
};

export const PolicyContainer: FC = () => {
    const {orgMnemonic, policyType } = useParams();
    const [organization, setOrganization] = useState<OrganizationInfo>(null);
    const [initialized, setInitialized] = useState(false);

    const PolicyComponent = policyComponents[policyType];
    
    useEffect(() => {
        let active = true;

        const load = async () => {
            try {
                if (!PolicyComponent) return;
                const org = await PolicyService.getOrganizationInfo(orgMnemonic);

                if (!active || !org.organizationPolicy) return;
                setOrganization(org);
            } finally {
                if (active) {
                    setInitialized(true);
                }
            }
        }
        load();
        
        return () => {
            active = false;
        }
    }, [orgMnemonic, policyType, PolicyComponent]);

    const shouldRender = initialized && organization && PolicyComponent;
    const notFound = initialized && !shouldRender;

    return (
        <div className="policy-content">
            {!initialized && <div>Load..</div>}
            {shouldRender && <PolicyComponent organization={organization} />}
            {notFound  && <div className="policy-header">Not Found</div>}
        </div>
    )
} 